import React from "react";
import Grid from "@material-ui/core/Grid";
import ButtonRounded from "../ButtonRounded";
import ModalContainer from "../ModalContainer";

import { IModalInfoProps } from "./Interfaces";
import {useModalSimpleStyles} from "../../common/styles/modalStyles";

const useStyles = useModalSimpleStyles;

const ModalDeleteUser: React.FC<IModalInfoProps> = ({
  text,
  message,
  open,
  onClose,
}) => {
  const classes = useStyles();

  return (
    <ModalContainer
      open={open}
      onClose={onClose}
      title={text}
      details={message}
    >
      <div className={classes.modalContent}>
        <Grid container spacing={2} className={classes.btnContainer}>
          <Grid item xs={3}></Grid>
          <Grid item xs={6}>
            <ButtonRounded
              fullWidth
              variant="contained"
              color="primary"
              onClick={onClose}
            >
              OK
            </ButtonRounded>
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>
      </div>
    </ModalContainer>
  );
};

export default ModalDeleteUser;
